import { motion } from 'framer-motion';
import { Search } from 'lucide-react';
import { PromptCard } from './PromptCard';
import type { Prompt } from '@/types/prompt';

interface PromptListProps {
  prompts: Prompt[];
  onViewDetail: (prompt: Prompt) => void;
  isLoading?: boolean;
}

export function PromptList({ prompts, onViewDetail, isLoading = false }: PromptListProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="h-56 md:h-64 bg-white/5 rounded-lg animate-pulse"
          />
        ))}
      </div>
    );
  }

  if (prompts.length === 0) {
    return (
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center py-12 md:py-16"
      >
        <div className="flex justify-center mb-4">
          <Search className="w-12 h-12 md:w-16 md:h-16 text-muted-foreground" />
        </div>
        <h3 className="text-lg md:text-xl font-semibold text-white mb-2">
          没有找到 Prompt
        </h3>
        <p className="text-sm md:text-base text-gray-400">
          试试调整搜索条件或筛选器
        </p>
      </motion.div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
      {prompts.map((prompt) => (
        <PromptCard
          key={prompt.id}
          prompt={prompt}
          onViewDetail={onViewDetail}
        />
      ))}
    </div>
  );
}

